module.exports = __webpack_public_path__ + "static/Booklet-08-703aa2378ef7bc4765dd97d39adec03b.png";